import { render, staticRenderFns } from "./Earth.vue?vue&type=template&id=64c15d83&scoped=true"
import script from "./Earth.vue?vue&type=script&lang=js"
export * from "./Earth.vue?vue&type=script&lang=js"
import style0 from "./Earth.vue?vue&type=style&index=0&id=64c15d83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c15d83",
  null
  
)

export default component.exports